@defer (when claim) {
<div class="container mt-4">
  <div class="row justify-content-center">
    <div class="col-12 w-100">
      <div class="heading-lg text-center">{{ claim?.policyType }}</div>
      <div class="heading-md text-center mb-3">{{ claim?.coverageType }} Claim</div>
      <div class="heading-sm mb-4 text-center">To be completed by the parent or legal guardian</div>
    </div>
  </div>
  <div class="row justify-content-center">
    <div class="col-12 col-lg-6 col-md-12">
      <div class="card">
        <!-- Using a custom class instead of overriding padding -->
        <div class="card-body">
          <form [formGroup]="claimForm">
            <div class="row mb-4">
              <div class="col-12">
                <div class="caption">
                  Claim number:&nbsp;
                  <span class="caption-lg">{{ claim?.claimReferenceNumber }}</span>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="heading-sm mb-4">I hereby certify to A.W.G. Dewar, Inc. that:</div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-xl-6" formGroupName="accountStudent">
                <div class="form-group mb-4">
                  <label for="firstName" class="form-label">Student first name</label>
                  <input type="text" class="form-control" id="firstName" formControlName="firstName" appShowFieldErrors="First name" maxlength="50" />
                </div>
              </div>
              <div class="col-12 col-xl-6" formGroupName="accountStudent">
                <div class="form-group mb-4">
                  <label for="lastName" class="form-label">Student last name</label>
                  <input type="text" class="form-control" id="lastName" formControlName="lastName" appShowFieldErrors="Last name" maxlength="50" />
                </div>
              </div>
            </div>
            @if (!(claim?.claimType === claimTypes.INVOLUNTARY_UNEMPLOYMENT)) {
              <div class="row">
                <div class="col-12">
                  <div class="caption mb-2">Has severed his/her connection with:</div>
                  <div class="heading-sm mb-3">{{ claim.accountName }}</div>
                </div>
              </div>
            }
            @if (claim?.claimType === claimTypes.WITHDRAWAL || claim?.claimType === claimTypes.DISMISSAL) {
              <div class="row align-items-center">
                <div class="col-12 col-lg-6">
                  <div class="form-group mb-4">
                    <label for="parentSeparationDate" class="form-label">As of</label>
                    <div class="input-group mb-3">
                      <input
                        class="form-control"
                        id="parentSeparationDate"
                        formControlName="parentSeparationDate"
                        placeholder="mm/dd/yyyy"
                        name="separationDate"
                        ngbDatepicker
                        appDateMask
                        [minDate]="minValidDate"
                        [maxDate]="maxValidDate"
                        firstDayOfWeek="7"
                        #separationDate="ngbDatepicker"
                        appShowFieldErrors="Separation date" />
                        <button class="btn btn-input-group" type="button" (click)="separationDate.toggle()">
                          <i class="bi bi-calendar3"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-lg-6 mb-4 mb-lg-0">
                    <div class="form-text">
                      {{ claim?.claimType === claimTypes.WITHDRAWAL ? withdrawalSeparationDateText : dismissalSeparationDateText }}
                    </div>
                  </div>
                </div>
                <div class="row mb-5">
                  <div class="col-12">
                    <div class="form-group mb-4 position-relative">
                      <label for="parentSeparationReason" class="form-label">
                        {{ claim?.claimType === claimTypes.WITHDRAWAL ? 'Reason for withdrawal' : 'Reason for dismissal' }}
                      </label>
                      <textarea
                        type="text"
                        id="parentSeparationReason"
                        class="form-control"
                        formControlName="parentSeparationReason"
                        appShowFieldErrors="{{ claim?.claimType === claimTypes.WITHDRAWAL ? 'Withdrawal reason' : 'Dismissal reason' }}"
                        maxlength="1000"
                      (input)="updateCharacterCount($event)"></textarea>
                      <div class="text-small form-text text-end char-count">{{ characterCount }}/1000 characters</div>
                    </div>
                  </div>
                </div>
              }

              @if (claim?.claimType === claimTypes.MEDICAL_ABSENCE || claim?.claimType === claimTypes.MEDICAL_WITHDRAWAL) {
                <div class="row mb-4">
                  <div class="col-12">
                    <div class="section-heading">Physician information</div>
                  </div>
                </div>

                <fieldset formGroupName="parentPhysician">
                  <div class="row">
                    <div class="col-12 col-xl-6">
                      <div class="form-group mb-4">
                        <label for="physicianFirstName" class="form-label">First name</label>
                        <input
                          type="text"
                          class="form-control"
                          id="physicianFirstName"
                          formControlName="firstName"
                          appShowFieldErrors="First name"
                          maxlength="50" />
                        </div>
                      </div>
                      <div class="col-12 col-xl-6">
                        <div class="form-group mb-4">
                          <label for="physicianLastName" class="form-label">Last name</label>
                          <input
                            type="text"
                            class="form-control"
                            id="physicianLastName"
                            formControlName="lastName"
                            appShowFieldErrors="Last name"
                            maxlength="50" />
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12 col-xl-6">
                          <div class="form-group mb-4">
                            <label for="phone" class="form-label">Phone</label>
                            <input
                              type="tel"
                              class="form-control"
                              id="phone"
                              inputmode="tel"
                              placeholder="(555) 555-5555"
                              mask="(000) 000-0000"
                              #phone
                              formControlName="phoneNumber"
                              appShowFieldErrors="Phone" />
                            </div>
                          </div>
                          <div class="col-12 col-xl-6">
                            <div class="form-group mb-4">
                              <label for="physicianEmail" class="form-label">Email address</label>
                              <input
                                type="text"
                                class="form-control"
                                id="physicianEmail"
                                formControlName="emailAddress"
                                appShowFieldErrors="Email"
                                maxlength="255" />
                              </div>
                            </div>
                          </div>
                        </fieldset>
                      }

                      @if (claim?.claimType === claimTypes.JOB_RELOCATION || claim?.claimType === claimTypes.INVOLUNTARY_UNEMPLOYMENT) {
                        <div class="row">
                          <div class="col-12 col-lg-12 mb-4">
                            <div class="form-text" [innerHTML]="certificationText"></div>
                          </div>
                        </div>
                      }

                      <!-- employer information -->
                      @if (claim?.claimType === claimTypes.INVOLUNTARY_UNEMPLOYMENT || claim?.claimType === claimTypes.JOB_RELOCATION) {
                        <div class="row mb-4">
                          <div class="col-12">
                            <div class="section-heading">Employer information</div>
                          </div>
                        </div>

                        <fieldset formGroupName="parentEmployer">
                          <div class="row">
                            <div class="col-12">
                              <div class="form-group mb-4 position-relative">
                                <label for="organizationName" class="form-label">Company name</label>
                                <textarea
                                  type="text"
                                  id="organizationName"
                                  class="form-control"
                                  formControlName="organizationName"
                                  appShowFieldErrors="Company name"
                                  maxlength="255"
                                (input)="updateCharacterCount($event)"></textarea>
                                <div class="text-small form-text text-end char-count">{{ characterCount }}/255 characters</div>
                              </div>
                            </div>
                          </div>

                          <div class="row mb-3">
                            <div class="col-12 col-xl-6">
                              <div class="form-group mb-4">
                                <label for="phone" class="form-label">Phone</label>
                                <input
                                  type="tel"
                                  class="form-control"
                                  id="phone2"
                                  inputmode="tel"
                                  placeholder="(555) 555-5555"
                                  mask="(000) 000-0000"
                                  #phone
                                  formControlName="phoneNumber"
                                  appShowFieldErrors="Phone" />
                                </div>
                              </div>
                              <div class="col-12 col-xl-6">
                                <div class="form-group mb-4">
                                  <label for="employerEmail" class="form-label">Email address</label>
                                  <input
                                    type="text"
                                    class="form-control"
                                    id="employerEmail"
                                    formControlName="emailAddress"
                                    appShowFieldErrors="Email"
                                    maxlength="255" />
                                  </div>
                                </div>
                              </div>
                            </fieldset>
                          }

                          <div class="row mb-4">
                            <div class="col-12">
                              <div class="section-heading">Parent, legal guardian or person financially responsible</div>
                            </div>
                          </div>
                          <fieldset formGroupName="parent">
                            <div class="row">
                              <div class="col-12 col-xl-6">
                                <div class="form-group mb-4">
                                  <label for="parentFirstName" class="form-label">First name</label>
                                  <input
                                    type="text"
                                    class="form-control"
                                    id="parentFirstName"
                                    formControlName="firstName"
                                    appShowFieldErrors="First name"
                                    maxlength="50" />
                                  </div>
                                </div>
                                <div class="col-12 col-xl-6">
                                  <div class="form-group mb-4">
                                    <label for="parentLastName" class="form-label">Last name</label>
                                    <input type="text" class="form-control" id="parentLastName" formControlName="lastName" appShowFieldErrors="Last name" maxlength="50" />
                                  </div>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-12 col-xl-6">
                                  <div class="form-group mb-4">
                                    <label for="phone" class="form-label">Phone</label>
                                    <input
                                      type="tel"
                                      class="form-control"
                                      id="phone3"
                                      inputmode="tel"
                                      placeholder="(555) 555-5555"
                                      mask="(000) 000-0000"
                                      #phone
                                      formControlName="phoneNumber"
                                      appShowFieldErrors="Phone" />
                                    </div>
                                  </div>
                                </div>
                              </fieldset>

                              @if (!(claim?.claimType === claimTypes.JOB_RELOCATION)) {
                                @if (claimForm.get('parentAddress')) {
                                  <app-address
                                    [addressFormGroup]="claimForm.get('parentAddress')"
                                    [addressLabel]="''"
                                    [showAddress2]="showAddress2"
                                    (toggleAddress2)="toggleAddress2()"
                                    [states]="states"
                                  [countries]="countries"></app-address>
                                }
                              }
                              @if (claim?.claimType === claimTypes.JOB_RELOCATION) {
                                @if (claimForm.get('parentAddress')) {
                                  <app-address
                                    [addressFormGroup]="claimForm.get('parentAddress')"
                                    [addressLabel]="'Original Address'"
                                    [showAddress2]="showAddress2"
                                    (toggleAddress2)="toggleAddress2()"
                                    [states]="states"
                                  [countries]="countries"></app-address>
                                }

                                <div class="row align-items-center">
                                  <div class="col-12 col-lg-6">
                                    <div class="form-group mb-4">
                                      <label for="parentRelocationDate" class="form-label">Date moved to new address</label>
                                      <div class="input-group mb-3">
                                        <input
                                          class="form-control"
                                          id="parentRelocationDate"
                                          formControlName="parentRelocationDate"
                                          placeholder="mm/dd/yyyy"
                                          name="relocationDate"
                                          ngbDatepicker
                                          appDateMask
                                          [minDate]="minValidDate"
                                          [maxDate]="maxValidDate"
                                          firstDayOfWeek="7"
                                          #relocationDate="ngbDatepicker"
                                          appShowFieldErrors="Relocation date" />
                                          <button class="btn btn-input-group" type="button" (click)="relocationDate.toggle()">
                                            <i class="bi bi-calendar3"></i>
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <app-address
                                    [addressFormGroup]="claimForm.get('parentNewAddress')"
                                    [addressLabel]="'New Address'"
                                    [showAddress2]="showNewAddress2"
                                    (toggleAddress2)="toggleNewAddress2()"
                                    [states]="states"
                                  [countries]="countries"></app-address>
                                }

                                <div class="row">
                                  <div class="col-12">
                                    <div class="caption mb-3">{{ settlementAuthorizationText }}</div>
                                  </div>
                                </div>
                                @if (claim?.claimType === claimTypes.DISMISSAL || claim?.claimType === claimTypes.WITHDRAWAL) {
                                  <div class="row">
                                    <div class="col-12">
                                      <div class="caption mb-3">{{ claim.parentAttendanceDisclaimer }}</div>
                                    </div>
                                  </div>
                                }
                                <div class="row">
                                  <div class="col-12">
                                    <div class="form-group mb-4">
                                      <label for="parentSignature" class="form-label">Signature of parent, legal guardian or person financially responsible</label>
                                      <app-signature-pad formControlName="parentSignature" appShowFieldErrors="Signature"></app-signature-pad>
                                      <div class="text-small form-text mt-2">{{ signatureText }}</div>
                                    </div>
                                  </div>
                                </div>
                              </form>
                              <div class="row">
                                <div class="col-12 text-center">
                                  <button class="btn btn-link" (click)="fraudNotice()">Important fraud information regarding your claim</button>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-12">
                                  <div class="caption mt-3" [innerHTML]="instructionText"></div>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-12 text-center">
                                  <button
                                    class="btn btn-primary me-3 mt-5 mb-5"
                                    (click)="onSubmit()"
                                    (keydown.enter)="onSubmit()"
                                    [disabled]="isSaving"
                                    [class.btn--waiting]="isSaving">
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Fraud Notices Modal Template -->
                    } @placeholder {
                    <div class="container mt-4">
                      <div class="row text-center">
                        <div class="col-12 heading-md pb-2">Loading Claim...</div>
                      </div>
                    </div>
                  }
